import axios from "axios";
import Vue from "vue";

import { appStore } from "@/main.js";

export default function setup() {
  const errorHandler = (error) => Promise.reject(error);

  const requestAuthTokenHandler = (request) => {
    // if (!request.url.includes('/api/auth/')) {
      const token = Vue.$cookies.get('token_c');

      if (token) request.headers["X-CSRF-TOKEN"] = token;
    // }
    return request;
  };

  const responseAuthRefreshTokenHandler = (error) => {
		// console.log(error.response, 'responseAuthRefreshTokenHandler')
		// console.log(error.config, 'responseAuthRefreshTokenHandler config')
    const originalRequest = error.config;

		// console.log(error.response?.status, 7777)
		// console.log(error.response?.data?.message, 888)
		// console.log(error.response?.status === 422 &&
		// 	['jwt expired', 'token data error'].includes(error.response?.data?.message), 9999)

		// refresh token
	  if (
		  [401, 422].includes(error.response?.status) &&
		  ['jwt expired', 'token data error', 'Token has expired'].some((msg) =>
			  error.response?.data?.message?.toLowerCase().includes(msg.toLowerCase())
		  )
	  ) {
			return new Promise(function (resolve, reject) {
				axios.post(process.env.VUE_APP_CONSTRUCTOR_URL + '/api/v1/auth/refresh', {}, {
					withCredentials: true,
				})
					.then((response) => {
						if(response?.data?.data?.accessToken) {
							Vue.$cookies.set(
								'token_c',
								response.data.data.accessToken,
								response.data.data.expiresIn,
							);

							axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.data.accessToken;
							originalRequest.headers['X-CSRF-TOKEN'] = response.data.data.accessToken;
							// appStore.dispatch('processInterceptionQueue', {
							// 	error: null,
							// 	token: response?.data.jwtToken
							// })
							resolve(axios(originalRequest));
						}
					})
					.catch((error) => {
						// appStore.dispatch('processInterceptionQueue', {
						// 	error: error,
						// 	token: null
						// })

						console.log('👉 Refresh failed, calling logout');
						appStore.dispatch('logout');
						reject(error);
					})
					.finally(() => {
						// appStore.dispatch('isTokenRefreshedFalse')
					})
			})
		}

    // refresh token
    // if(error.response?.status === 401 && !originalRequest._retry) {
		//
    //   if (appStore.state.getIsTokenRefreshed) {
    //     return new Promise(function(resolve, reject) {
    //       appStore.dispatch('pushToFailedInterceptorsQueue', {resolve, reject})
    //     }).then((token) => {
    //       originalRequest.headers['Authorization'] = `Bearer ${token}`;
    //       return axios(originalRequest);
    //     }).catch((_error) => errorHandler(_error))
    //   }
		//
    //   originalRequest._retry = true;
    //   appStore.dispatch('isTokenRefreshedTrue')
		//
    //   let data = {
    //     userId: Vue.$cookies.get('auth_user_id'),
    //     refreshToken: Vue.$cookies.get('auth_refresh_token')
    //   }
		//
    //   return new Promise(function (resolve, reject) {
    //     axios.post(process.env.VUE_APP_BASEURL + '/api/auth/refresh-token', data)
    //       .then((response) => {
		//
    //         //check if rememberMe active
    //         let expires, rememberMeCookie = Vue.$cookies.get('auth_remember_me')
    //         if(rememberMeCookie != 'false') {
    //           expires = process.env.VUE_APP_LOGIN_WITH_RM_DAYS + 'd'
    //         } else {
    //           expires = process.env.VUE_APP_LOGIN_WITHOUT_RM_HOURS + 'h'
    //         }
		//
    //         appStore.dispatch('_authAddState', response);
    //         Vue.$cookies.set('auth_token_jwt', response?.data?.jwtToken, expires);
    //         Vue.$cookies.set('auth_refresh_token', response?.data?.refreshToken, expires);
		//
    //         axios.defaults.headers.common['Authorization'] = 'Bearer ' + response?.data.jwtToken;
    //         originalRequest.headers['Authorization'] = 'Bearer ' + response?.data.jwtToken;
    //         appStore.dispatch('processInterceptionQueue', {
    //           error: null,
    //           token: response?.data.jwtToken
    //         })
    //         resolve(axios(originalRequest));
    //       })
    //       .catch((error) => {
    //         appStore.dispatch('processInterceptionQueue', {
    //           error: error,
    //           token: null
    //         })
    //         appStore.dispatch('logout');
    //         reject(error);
    //       })
    //       .finally(() => { appStore.dispatch('isTokenRefreshedFalse') })
    //   })
    // }

    return errorHandler(error);
  };

  axios.interceptors.request.use(
    (request) => requestAuthTokenHandler(request),
    (error) => errorHandler(error),
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => responseAuthRefreshTokenHandler(error)
  );
}
